import type { LanguageCode } from "@frontend/lib/graphql/generated-gql";
import { z } from "zod";
import type { StateCreator } from "zustand";
import type { Store } from "../globalStore";

export const userStrictSchema = z.object({
  fname: z.string().min(1),
  lname: z.string().min(1),
  email: z.string().email().or(z.string().length(0)),
  phone: z.string(),
});

export interface User {
  id: string;
  fname: string;
  lname: string;
  email: string;
  phone: string;
  verifiedFlag: boolean;
  orgId: number | undefined | null;
  primaryLanguage: LanguageCode;
}

export interface UserSlice {
  user: User;
  setUser: (user: User) => void;
}

export const defaultUser = {
  id: "",
  fname: "",
  lname: "",
  email: "",
  phone: "",
  verifiedFlag: false,
  orgId: undefined,
  primaryLanguage: "en" as LanguageCode,
};

export const userInitialState = { user: defaultUser };

export const createUserSlice: StateCreator<
  Store,
  [["zustand/devtools", never], ["zustand/persist", unknown]],
  [],
  UserSlice
> = (set, get) => ({
  ...userInitialState,
  setUser: (user) => {
    set({ user: user });
  },
});
